import Deletion from './Deletion';
import { frontendURL } from '../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('deletion'),
      name: 'deletion',
      component: Deletion,
      props: route => ({
        id: route.query.id,
      }),
    },
  ],
};
